import { useState, type FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { login } from '../api/auth';
import { ApiError } from '../api/client';
import { useAuth } from './auth/AuthContext';

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setOperator } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await login(username, password);
      setOperator(res.operator);
      const next = (location.state as { from?: string } | null)?.from ?? '/admin';
      navigate(next, { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError('Nieprawidłowy login lub hasło.');
      } else {
        setError('Nie udało się zalogować. Spróbuj ponownie.');
        console.error(err);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--admin-bg, #1A0E08)',
        color: 'var(--admin-text, #E8E2D5)',
        padding: 24,
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: '100%',
          maxWidth: 360,
          background: 'var(--admin-panel, #221610)',
          padding: 24,
          border: '1px solid #2A1B12',
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
        }}
      >
        <h1 style={{ fontFamily: 'var(--display)', fontSize: 22, margin: 0 }}>
          Operacja Teneryfa · Admin
        </h1>
        <p style={{ margin: 0, fontSize: 12, opacity: 0.6 }}>
          Zaloguj się, aby zarządzać sklepem.
        </p>

        <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12 }}>
          Login
          <input
            className="input-a"
            type="text"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 4, fontSize: 12 }}>
          Hasło
          <input
            className="input-a"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        {error && (
          <div style={{ color: '#E07C5A', fontSize: 12 }} role="alert">
            {error}
          </div>
        )}

        <button className="btn-a primary" type="submit" disabled={submitting}>
          {submitting ? 'Logowanie…' : 'Zaloguj się'}
        </button>
      </form>
    </div>
  );
}
